import { render, staticRenderFns } from "./ItemForm.vue?vue&type=template&id=6bb7a115&"
import script from "./ItemForm.vue?vue&type=script&lang=ts&"
export * from "./ItemForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports